"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ECreateStatus = exports.ECreateError = void 0;
let ECreateStatus = exports.ECreateStatus = /*#__PURE__*/function (ECreateStatus) {
  ECreateStatus["Initial"] = "initial";
  ECreateStatus["Loading"] = "loading";
  ECreateStatus["Succeed"] = "succeed";
  ECreateStatus["Failed"] = "failed";
  return ECreateStatus;
}({});
let ECreateError = exports.ECreateError = /*#__PURE__*/function (ECreateError) {
  ECreateError["Common"] = "common";
  ECreateError["MergeRequired"] = "mergeRequired";
  ECreateError["LicenceNotAccepted"] = "licenceNotAccepted";
  ECreateError["BlockedRegistrationForSocialNetwork"] = "blockedRegistrationForSocialNetwork";
  ECreateError["Unexpected"] = "unexpected";
  return ECreateError;
}({});